<template>
  <Dialog :show.sync="visible" width="500px" title="默认带宽">
    <template v-slot:body>
      <div class="dialog-body">
        <el-form :model="formData" ref="formRef" label-width="auto">
          <el-form-item prop="fLow" label="低通截止">
            <el-input-number controls-position="right" :min="0" v-model="formData.fLow" style="width: 100%"/>
          </el-form-item>
          <el-form-item prop="fHigh" label="高通截止">
            <el-input-number controls-position="right" :min="0" v-model="formData.fHigh" style="width: 100%"/>
          </el-form-item>
        </el-form>
      </div>
    </template>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('cancel_k') }}</el-button>
      <el-button type="primary" @click="reset">{{ $t('Reset') }}</el-button>
      <el-button type="primary" @click="save" :loading="loading">{{ $t('confirm_k') }}</el-button>
    </div>
  </Dialog>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      loading: false,
      formData: {
        fLow: 1,
        fHigh: 100,
      },
    }
  },
  methods: {
    open() {
      this.visible = true
    },
    reset(){

    },
    save(){
      this.loading = true
      this.$emit('success',this.formData)
      this.visible = false
      this.loading = false
    }
  }
}
</script>
<style scoped lang="scss">

</style>
